(function() {
    const InvioCredenzialiSezioneService = function($http, CONSTANTS) {
        this.inviaCredenziale = (tipoCredenziale, codiceMito, canale, canaleValore) => {
            const valore = canale === 'SMS' ? canaleValore.numero : canaleValore;
            const params = {
                codiceMito: codiceMito,
                canale: canale,
                canaleValore: valore,
                prefissoInternazionale: !!canaleValore.prefisso ? canaleValore.prefisso : null
            };
            const urlSpecifico = tipoCredenziale === 'codice' ? CONSTANTS.REST.CREDENZIALI.CODICE : CONSTANTS.REST.CREDENZIALI.PASSWORD;
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + urlSpecifico,
                data: params
            });
        };

        this.leggiLimiti = (idOrganizzazione) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CREDENZIALI.LIMITI + idOrganizzazione
            });
        };

        this.verificaCodiceAttivazioneDigitale = (codiceUtente) => {
            return $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CREDENZIALI.CHECK_CAD + codiceUtente
            });
        };

        this.inviaCodiceAttivazioneDigitale = (codiceUtente) => {
            const params = { };
            return $http({
                method: 'POST',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CREDENZIALI.RESET_CAD + codiceUtente,
                data: params
            });
        };
    };

    InvioCredenzialiSezioneService.$inject = [ '$http', 'Mitom_CONSTANTS' ];

    angular
        .module('cbl.mitomanager.wa')
        .service(
            'MitomInvioCredenzialiSezioneService',
            InvioCredenzialiSezioneService
        );
})();